<template>
  <div id="register">
    <div class="van-hairline--bottom background_color_d6f1ec font_weight_bold" style="z-index: 1;" v-show="$vuetify.breakpoint.smAndDown">
      <v-row gutter="5" type="flex" align="center" justify="space-between">
        <v-col cols="2" />
        <v-col cols="8">
          <div class="background_color_d6f1ec van-nav-bar">
            <div class="van-ellipsis van-nav-bar__title">{{ $t("login.register") }}</div>
          </div>
        </v-col>
        <v-col cols="2" class="margin_top_12" v-show="$enableShoppingCart">
          <!-- <div class="van-nav-bar__right" style="top: 15px;">
            <wc-tabbar-cart />
          </div>-->
          <!-- <wc-tabbar-cart /> -->
        </v-col>
      </v-row>
    </div>

    <div class="content2">
      <img src="../assets/img/icon_logo_2.png" class="logo_banner" />

      <div class="login_account_bar">
        <div class="login_bar">
          <img src="../assets/img/icon_yx.png" class="img-text-top-middle" />
          <input class="login_input font_14" type="text" placeholder="email" v-model="email" id="email" autocomplete="new-password" />
        </div>
        <div class="login_bar">
          <img src="../assets/img/icon_yx.png" class="img-text-top-middle" />
          <input class="login_input font_14" type="text" placeholder="confirm email" id="email_confirm" autocomplete="new-password" />
        </div>
        <div class="login_bar">
          <img src="../assets/img/icon_mima.png" class="img-text-top-middle" />
          <input
            class="login_input font_14"
            type="password"
            placeholder="password"
            v-model="pwd"
            id="pwd"
            autocomplete="new-password"
            required
          />
        </div>
        <div class="login_bar">
          <img src="../assets/img/icon_mima.png" class="img-text-top-middle" />
          <input
            class="login_input font_14"
            type="password"
            placeholder="confirm password"
            id="pwd_confirm"
            autocomplete="new-password"
            required
          />
        </div>
      </div>

      <div class="padding_20">
        <v-row>
          <v-col>
            <v-btn class="btn_login" outlined rounded @click="toRegister"> {{ $t("login.register") }} </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {
      email: "",
      pwd: "",
    };
  },
  mounted() {
    this.$parent.curTab = 4;
  },
  methods: {
    // ------------------------------------------------------------------------ toRegister
    toRegister() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        email: $this.email,
        password: $this.pwd,
      };

      function passwordValid() {
        var password = document.getElementById("pwd");
        var password_confirm = document.getElementById("pwd_confirm");

        if (password.value != password_confirm.value) {
          $this.$toast({
            message: "Password does not match",
            position: "bottom",
          });
          return false;
        } else if (password.value.length < 1) {
          $this.$toast({
            message: "Please enter a password",
            position: "bottom",
          });
          return false;
        }
        return true;
      }

      function emailValid() {
        var email = document.getElementById("email");
        var email_confirm = document.getElementById("email_confirm");

        var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (regex.test(email.value) == false) {
          $this.$toast({
            message: "Invalid eMail address",
            position: "bottom",
          });
          return false;
        } else if (email.value != email_confirm.value) {
          $this.$toast({
            message: "eMail does not match",
            position: "bottom",
          });
          return false;
        }
        return true;
      }

      if (emailValid() && passwordValid()) {
        $this.$ajax2
          .post("RegisterMember", obj, $this.$ajaxHeader)
          .then(function(rpdata) {
            if (rpdata.data.meta.code == "200") {
              $this.$toast({
                message: $this.$t("register.success"),
                position: "bottom",
              });
              $this.$ajax2
                .post("ValidateMember", obj, $this.$ajaxHeader)
                .then(function(rpdata) {
                  if (rpdata.data.meta.code == "200") {
                    $this.$store.commit("member", rpdata.data.data);
                    $this.$router.push({ name: "member" });
                  } else {
                    $this.$store.commit("member", {});
                  }
                })
                .catch(function(err) {}); // eslint-disable-line
            } else {
              $this.$toast({
                message: rpdata.data.meta.msg,
                position: "bottom",
              });
            }
          })
          .catch(function(err) {}); // eslint-disable-line
      }
    },
  },
};
</script>

<style>
#register .btn_login {
  color: indigo;
  text-transform: none !important;
  margin-left: 5%;
  margin-right: 5%;
  width: 90%;
}
#register .login_input {
  width: 75%;
  border: 0;
  padding: 0 20px;
}
#register .login_account_bar {
  margin: 15% 5% 5% 5%;
}
#register .login_bar {
  padding: 15px 10px;
  border-bottom: 1px solid #eeeeee;
}
#register .logo {
  width: 20%;
  display: block;
  margin: 0 auto;
  padding-top: 40px;
}
#register .logo_banner {
  width: 80%;
  display: block;
  margin: 0 auto;
  padding-top: 20px;
}
#register {
  background-color: white;
  /* height: -webkit-fill-available; */
}
</style>
